import { RoadDetailInfo as L2RRoadDetailInfo } from "@l2r-front/l2r-networks"
import { styled } from "@l2r-front/l2r-ui"

export const Container = styled("div")(({ theme }) => ({
    height: "100%",
    padding: theme.spacing(0, 8, 8, 8),
}))

export const ContentWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(5),
}))

export const RoadDetailInfo = styled(L2RRoadDetailInfo)(({ isMobile, theme }) => ({
    marginTop: !isMobile && theme.spacing(5),
}))